<template lang="pug">
.container
  .nav-grid
    .nav-item(v-for="item, index in menu" :key="index" @click="toggleNavItem(index)" :class="{'is-active' : showByIndex  === index}")
      .nav-item__header
        h3.nav-item__title {{item.title}}
      .nav-item__body
        nav.nav-list
          a.nav-list__link(:key="subitem.name" v-for="subitem in item.submenu" :href="subitem.link") {{subitem.name}}
  .footer-delimetr
  .footer__row
    .footer__left
      social.footer__social-list(opacity)
    .footer__right
      .footer-info-list
        .footer-info-item
          h3.footer-info-item__title Контакты
          a.footer-info-item__link(href="tel:+74952343300") +7&nbsp;495&nbsp;234&nbsp;33&nbsp;00
          a.footer-info-item__link(href="mailto:info@belkacar.ru") info@belkacar.ru
        .footer-info-item
          h3.footer-info-item__title Локация
          p.footer-info-item__text Павелецкая наб., 2с1,#[br] Москва, Россия, 115114

</template>

<script>
import Social from './../components/Social'

export default {
  props: [],
  components: { Social },
  data () {
    return {
      showByIndex: null,
      menu: [
        {
          title: 'Парковка в аэропортах',
          submenu: [
            {
              name: 'Внуково',
              link: '#'
            },
            {
              name: 'Шереметьево',
              link: '#'
            },
            {
              name: 'Аэропорт г. Сочи',
              link: '#'
            }
          ]
        },
        {
          title: 'Корпоративным клиентам',
          submenu: [
            {
              name: 'Тарифы',
              link: '#'
            },
            {
              name: 'Описание',
              link: '#'
            }
          ]
        },
        {
          title: 'Тарифы',
          submenu: [
            {
              name: '1',
              link: '#'
            },
            {
              name: '2',
              link: '#'
            },
            {
              name: '3',
              link: '#'
            }
          ]
        },
        {
          title: 'Часто задаваемые вопросы',
          submenu: [
            {
              name: 'Для корпоративных клиентов',
              link: '#'
            },
            {
              name: 'Для частных лиц',
              link: '#'
            }
          ]
        },
        {
          title: 'Правила использования сервиса',
          submenu: [
            {
              name: 'Паркинг',
              link: '#'
            },
            {
              name: 'КАСКО',
              link: '#'
            },
            {
              name: 'Аэропорты',
              link: '#'
            },
            {
              name: 'Бензин',
              link: '#'
            },
            {
              name: 'Зоны',
              link: '#'
            }
          ]
        },
        {
          title: 'Пресс-центр',
          submenu: [
            {
              name: 'Новости',
              link: '#'
            },
            {
              name: 'Пресса о Нас',
              link: '#'
            },
            {
              name: 'Блог',
              link: '#'
            },
            {
              name: 'Бренд BelkaCar',
              link: '#'
            },
            {
              name: 'Контакты для прессы ',
              link: '#'
            }
          ]
        },
        {
          title: 'О компании',
          submenu: [
            {
              name: 'История',
              link: '#'
            },
            {
              name: 'О компании',
              link: '#'
            },
            {
              name: 'Основатели',
              link: '#'
            }
          ]
        }
      ]
    }
  },
  methods: {
    toggleNavItem (index) {
      this.showByIndex === index ? this.showByIndex = null : this.showByIndex = index
    }
  },
  computed: {

  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/nav-grid.vue